<template>
  <div class="card-div">
    <div class="header">
      <div v-if="props.title" class="title">{{ props.title }}</div>
      <slot v-else name="header"></slot>
      <div @click="more_click_fn" v-if="props.more_url" class="more-icon">
        <van-icon name="arrow" color="#999999" size="16" />
      </div>
    </div>
    <slot name="content"></slot>
  </div>
</template>
<script setup lang="ts">
import { defineProps } from 'vue'
import { useRouter } from 'vue-router'

const props = defineProps<{
  /** 标题 */
  title?: string,
  /** more跳转url */
  more_url?: any
}>()


const router = useRouter()

const more_click_fn = () => {
  if(props.more_url.indexOf('http') > -1) {
    window.location.href = props.more_url as string
  } else {
    // 项目内路由跳转
    router.push(props.more_url)
  }
}
</script>
<style lang='scss' scoped>
.card-div {
  width: 100%;
  box-shadow: 0 4px 24px 0 #ededed;
  border: 1px solid #ededed;
  border-radius: 16px;
  overflow: hidden;
  background-color: white;
  margin-top: 16px;
  .header {
    padding: 0 20px;
    display: flex;
    align-items: center;
    
    .title {
      font-size: var(--font_size_h2);
      color: var(--font_color_title);
      font-weight: 700;
      height: 80px;
      line-height: 80px;
      flex: 1;
      width: 100px;
    }
    .more-icon{
      margin-right: -20px;
      height: 80px;
      line-height: 80px;
      width: 70px;
      text-align: right;
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }
}
</style>